export default __webpack_public_path__ + "media/fonts/FiraMono/FiraMono-Regular-85c5f914830723df87beaee16cd70fbc.otf";